import React from "react";
import { CardBody, Col, Row } from "react-bootstrap";
import "../index.scss";
import { useSelector } from "react-redux";
import { formatAmount } from "../../../utils/helper";

const Details = () => {
  const detailsData = useSelector(
    (state) => state.orders.selectedOrder.detailsData
  );

  return (
    <CardBody>
      <div className="details">
        <Row className="details-wrapper">
          <Col xs="12" md="6">
            <Row className="details-content">
              <Col className="form-head">Order Id : </Col>
              <Col className="form-data">{detailsData.code}</Col>
            </Row>
          </Col>
          <Col xs="12" md="6">
            <Row className="details-content">
              <Col className="form-head">Order Date : </Col>
              <Col className="form-data">{detailsData.created_date}</Col>
            </Row>
          </Col>
          <Col xs="12" md="6">
            <Row className="details-content">
              <Col className="form-head">Customer : </Col>
              <Col className="form-data">{detailsData.billing_name}</Col>
            </Row>
          </Col>
          <Col xs="12" md="6">
            <Row className="details-content">
              <Col className="form-head">AG : </Col>
              <Col className="form-data">{detailsData.ag_name}</Col>
            </Row>
          </Col>
          <Col xs="12" md="6">
            <Row className="details-content">
              <Col className="form-head">Product Type : </Col>
              <Col className="form-data">{detailsData.product_type}</Col>
            </Row>
          </Col>
          <Col xs="12" md="6">
            <Row className="details-content">
              <Col className="form-head">Product : </Col>
              <Col className="form-data">{detailsData.name}</Col>
            </Row>
          </Col>
          <Col xs="12" md="6">
            <Row className="details-content">
              <Col className="form-head">Product Price : </Col>
              <Col className="form-data">{formatAmount(detailsData.gross_amount, null, null, null)}</Col>
            </Row>
          </Col>
          {/* <Col xs="12" md="6">
            <Row className="details-content">
              <Col className="form-head">Amount Paid : </Col>
              <Col className="form-data">{detailsData.gross_amount}</Col>
            </Row>
          </Col> */}
          <Col xs="12" md="6">
            <Row className="details-content">
              <Col className="form-head">Order Type : </Col>
              <Col className="form-data">{detailsData.order_type}</Col>
            </Row>
          </Col>
          <Col xs="12" md="6">
            <Row className="details-content">
              <Col className="form-head">Status : </Col>
              <Col className="form-data">{detailsData.status}</Col>
            </Row>
          </Col>
          <Col xs="12" md="6">
            <Row className="details-content">
              <Col className="form-head">Relationship Manager : </Col>
              <Col className="form-data">{detailsData.rm_name}</Col>
            </Row>
          </Col>
        </Row>
      </div>
    </CardBody>
  );
};

export default Details;
